// Local athletic colour palette (replaces the Payload `colors` collection).
// Each column is one hue family, light -> dark.
export const COLOR_COLUMNS = [
    [
        { hex: '#ccff00', name: 'Neon Yellow' },
        { hex: '#aaff00', name: 'Neon Yellow-Green' },
        { hex: '#ff6600', name: 'Neon Orange' },
        { hex: '#ff00ff', name: 'Neon Magenta' },
        { hex: '#80ff00', name: 'Neon Green' },
    ],
    [
        { hex: '#4dff91', name: 'Neon Green Light' },
        { hex: '#00c957', name: 'Kelly Green' },
        { hex: '#00a550', name: 'Athletic Green' },
        { hex: '#007a33', name: 'Forest Green' },
        { hex: '#00521f', name: 'Dark Forest' },
        { hex: '#002b10', name: 'Deep Forest' },
    ],
    [
        { hex: '#00ffcc', name: 'Neon Cyan' },
        { hex: '#00d4aa', name: 'Bright Teal' },
        { hex: '#00a896', name: 'Teal' },
        { hex: '#007b6e', name: 'Dark Teal' },
        { hex: '#005247', name: 'Deep Teal' },
    ],
    [
        { hex: '#b3ecff', name: 'Pale Blue' },
        { hex: '#56c5f0', name: 'Carolina Blue Light' },
        { hex: '#13a9e0', name: 'Carolina Blue' },
        { hex: '#1d428a', name: 'Royal Blue' },
        { hex: '#0d2240', name: 'Navy' },
        { hex: '#070f1e', name: 'Deep Navy' },
    ],
    [
        { hex: '#d4b3ff', name: 'Lavender' },
        { hex: '#a97fe0', name: 'Light Purple' },
        { hex: '#7b2fbe', name: 'Purple' },
        { hex: '#552583', name: 'Regal Purple' },
        { hex: '#3b1160', name: 'Deep Purple' },
        { hex: '#1e0033', name: 'Dark Violet' },
    ],
    [
        { hex: '#ffb3c6', name: 'Light Pink' },
        { hex: '#ff6b9d', name: 'Hot Pink' },
        { hex: '#e8478b', name: 'Pink' },
        { hex: '#c4286e', name: 'Deep Pink' },
    ],
    [
        { hex: '#ff9999', name: 'Light Red' },
        { hex: '#ff5050', name: 'Bright Red' },
        { hex: '#e03030', name: 'Red' },
        { hex: '#ce1141', name: 'Cardinal Red' },
        { hex: '#8b0000', name: 'Dark Red' },
        { hex: '#4a0000', name: 'Deep Crimson' },
    ],
    [
        { hex: '#ffb347', name: 'Light Orange' },
        { hex: '#ff8c00', name: 'Orange' },
        { hex: '#e05c00', name: 'Burnt Orange' },
        { hex: '#b84700', name: 'Deep Burnt Orange' },
    ],
    [
        { hex: '#ffd700', name: 'Gold' },
        { hex: '#c9a227', name: 'Dark Gold' },
        { hex: '#a0722a', name: 'Tan / Khaki' },
        { hex: '#6b3f00', name: 'Brown' },
    ],
];

// Starting colours: pattern slot i gets DEFAULT_PATTERN_COLORS[i]; every stripe
// colour slot starts as DEFAULT_STRIPE_COLOR.
export const DEFAULT_PATTERN_COLORS = ['#56c5f0', '#13a9e0', '#1d428a', '#0d2240'];
export const DEFAULT_STRIPE_COLOR = '#ffd700';

export const GREY_SWATCHES = [
    { hex: '#ffffff', name: 'White' },
    { hex: '#e8e8e8', name: 'Near White' },
    { hex: '#d0d0d0', name: 'Light Grey' },
    { hex: '#b8b8b8', name: 'Silver' },
    { hex: '#a0a0a0', name: 'Light Mid Grey' },
    { hex: '#808080', name: 'Mid Grey' },
    { hex: '#606060', name: 'Dark Mid Grey' },
    { hex: '#505050', name: 'Charcoal' },
    { hex: '#303030', name: 'Dark Charcoal' },
    { hex: '#000000', name: 'Black' },
];
